<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="update-subscription-period-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Update Subscription Period
                        </h4>
                    </div>

                    <div class="modal-body">
                        <number-form-group
                                v-model="data.price"
                                name="price"
                                label="Price"
                                :error="getError('price')"
                                :disabled="subscriptionPeriod && subscriptionPeriod.status !== 'uninvoiced'"
                        ></number-form-group>

                        <date-form-group
                                v-model="data.starts_at"
                                name="starts_at"
                                label="Starts At"
                                :error="getError('starts_at')"
                                format="DD.MM.YYYY"
                                :disabled="subscriptionPeriod && subscriptionPeriod.status !== 'uninvoiced'"
                        ></date-form-group>

                        <date-form-group
                                v-model="data.ends_at"
                                name="ends_at"
                                label="Ends At"
                                :error="getError('ends_at')"
                                format="DD.MM.YYYY"
                                :disabled="subscriptionPeriod && subscriptionPeriod.status !== 'uninvoiced'"
                        ></date-form-group>

                        <date-form-group
                                v-model="data.closes_at"
                                name="closes_at"
                                label="Closes At"
                                :error="getError('closes_at')"
                                format="DD.MM.YYYY"
                                :disabled="(subscriptionPeriod && subscriptionPeriod.status === 'uninvoiced') || !hasPermission('admin')"
                        ></date-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import moment from 'moment'
    import Errors from '@/mixins/Errors'
    import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
    import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
    import Permissions from '@/mixins/Permissions'

    export default {
        components: {DateFormGroup, NumberFormGroup},

        mixins: [Errors, Permissions],

        props: ['subscriptionPeriod'],

        data() {
            return {
                data: {}
            }
        },

        watch: {
            subscriptionPeriod(value) {
                this.data = {
                    price: value.price,
                    starts_at: moment(value.starts_at).format('YYYY-MM-DD'),
                    ends_at: moment(value.ends_at).format('YYYY-MM-DD'),
                    closes_at: moment(value.closes_at).format('YYYY-MM-DD')
                }
            }
        },

        mounted() {
            this.listenForClose()
        },

        methods: {
            listenForClose() {
                $('#update-subscription-period-modal').on('hidden.bs.modal', this.reset)
            },

            submit() {
                http.put('/api/v1/subscription-periods/' + this.subscriptionPeriod.id, this.data)
                    .then(response => {
                        notify.success('The subscription period was updated')

                        this.$emit('updated', response.data.data)

                        $('#update-subscription-period-modal').modal('hide')
                    })
                    .catch(this.catchValidationErrors)
            },

            reset() {
                this.errors = {}

                this.data = {
                    price: this.subscriptionPeriod.price,
                    starts_at: moment(this.subscriptionPeriod.starts_at).format('YYYY-MM-DD'),
                    ends_at: moment(this.subscriptionPeriod.ends_at).format('YYYY-MM-DD'),
                    closes_at: moment(this.subscriptionPeriod.closes_at).format('YYYY-MM-DD')
                }
            }
        }
    }
</script>
